import React, { useEffect, useState } from 'react';

import { getProductsByPrice } from '../services/products.service';

import ProductCard from './ProductCard';

function ProductsSidebar({ maxAmount = 0 }) {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;

    const fetchProducts = async () => {
      const amount = Number(maxAmount) || 0;

      if (amount <= 0) {
        setProducts([]);
        setError('');
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      const {data, success, error} = await getProductsByPrice(amount);

      if (!isMounted) {
        return;
      }

      setIsLoading(false);

      if (success) {
        data.sort((a, b) => b.price - a.price);
        setProducts(data || []);
        setError('');
      } else {
        setProducts([]);
        setError(error);
      }
    };

    fetchProducts();

    return () => {
      isMounted = false;
    };
  }, [maxAmount]);

  return (
    <aside className="d-flex flex-column" style={{top: '110px'}}>
      <div>
        <p className="fw-bold mb-1" style={{fontSize: '1.5rem', color: 'var(--color-text-dark)'}}>
          Productos
        </p>
      </div>
      {isLoading && (
        <div className="bg-white rounded-3 p-3 border-2 border-light shadow-sm">
          <p className="mb-0 text-muted">Cargando productos...</p>
        </div>
      )}
      {error && (
        <div className="bg-white rounded-3 p-3 border-2 border-light shadow-sm">
          <p className="mb-0 text-danger">{error}</p>
        </div>
      )}
      {!isLoading && !error && products?.length === 0 && (
        <div className="bg-white rounded-3 p-3 border-2 border-light shadow-sm">
          <p className="mb-0 text-muted">No hay productos para mostrar.</p>
        </div>
      )}
      {products.slice(0, 5).map((product) => (
        <ProductCard
          key={`product-${product.id}`}
          product={product}
        />
      ))}
    </aside>
  );
}

export default ProductsSidebar;
